/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { deleteHabitId } from '../fn/habit/delete-habit-id';
import { DeleteHabitId$Params } from '../fn/habit/delete-habit-id';
import { getHabit$Json } from '../fn/habit/get-habit-json';
import { GetHabit$Json$Params } from '../fn/habit/get-habit-json';
import { getHabit$Plain } from '../fn/habit/get-habit-plain';
import { GetHabit$Plain$Params } from '../fn/habit/get-habit-plain';
import { getHabitId$Json } from '../fn/habit/get-habit-id-json';
import { GetHabitId$Json$Params } from '../fn/habit/get-habit-id-json';
import { getHabitId$Plain } from '../fn/habit/get-habit-id-plain';
import { GetHabitId$Plain$Params } from '../fn/habit/get-habit-id-plain';
import { Habit } from '../models/habit';
import { HabitPagedResult } from '../models/habit-paged-result';
import { postHabit$Json } from '../fn/habit/post-habit-json';
import { PostHabit$Json$Params } from '../fn/habit/post-habit-json';
import { postHabit$Plain } from '../fn/habit/post-habit-plain';
import { PostHabit$Plain$Params } from '../fn/habit/post-habit-plain';
import { putHabitId } from '../fn/habit/put-habit-id';
import { PutHabitId$Params } from '../fn/habit/put-habit-id';

@Injectable({ providedIn: 'root' })
export class HabitService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getHabit()` */
  static readonly GetHabitPath = '/habit';

  /**
   * Get all Habits.
   *
   * Get all Habits
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getHabit$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getHabit$Plain$Response(params?: GetHabit$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<HabitPagedResult>> {
    const obs = getHabit$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get all Habits.
   *
   * Get all Habits
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getHabit$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getHabit$Plain(params?: GetHabit$Plain$Params, context?: HttpContext): Observable<HabitPagedResult> {
    const resp = this.getHabit$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<HabitPagedResult>): HabitPagedResult => r.body)
    );
  }

  /**
   * Get all Habits.
   *
   * Get all Habits
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getHabit$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getHabit$Json$Response(params?: GetHabit$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<HabitPagedResult>> {
    const obs = getHabit$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get all Habits.
   *
   * Get all Habits
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getHabit$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getHabit$Json(params?: GetHabit$Json$Params, context?: HttpContext): Observable<HabitPagedResult> {
    const resp = this.getHabit$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<HabitPagedResult>): HabitPagedResult => r.body)
    );
  }

  /** Path part for operation `postHabit()` */
  static readonly PostHabitPath = '/habit';

  /**
   * Create a Habit.
   *
   * Create a Habit
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postHabit$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postHabit$Plain$Response(params?: PostHabit$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Habit>> {
    const obs = postHabit$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Create a Habit.
   *
   * Create a Habit
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postHabit$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postHabit$Plain(params?: PostHabit$Plain$Params, context?: HttpContext): Observable<Habit> {
    const resp = this.postHabit$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Habit>): Habit => r.body)
    );
  }

  /**
   * Create a Habit.
   *
   * Create a Habit
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postHabit$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postHabit$Json$Response(params?: PostHabit$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Habit>> {
    const obs = postHabit$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Create a Habit.
   *
   * Create a Habit
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postHabit$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postHabit$Json(params?: PostHabit$Json$Params, context?: HttpContext): Observable<Habit> {
    const resp = this.postHabit$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Habit>): Habit => r.body)
    );
  }

  /** Path part for operation `getHabitId()` */
  static readonly GetHabitIdPath = '/habit/{id}';

  /**
   * Get a Habit by id.
   *
   * Get a Habit by id
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getHabitId$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getHabitId$Plain$Response(params: GetHabitId$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Habit>> {
    const obs = getHabitId$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get a Habit by id.
   *
   * Get a Habit by id
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getHabitId$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getHabitId$Plain(params: GetHabitId$Plain$Params, context?: HttpContext): Observable<Habit> {
    const resp = this.getHabitId$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Habit>): Habit => r.body)
    );
  }

  /**
   * Get a Habit by id.
   *
   * Get a Habit by id
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getHabitId$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getHabitId$Json$Response(params: GetHabitId$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Habit>> {
    const obs = getHabitId$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get a Habit by id.
   *
   * Get a Habit by id
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getHabitId$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getHabitId$Json(params: GetHabitId$Json$Params, context?: HttpContext): Observable<Habit> {
    const resp = this.getHabitId$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Habit>): Habit => r.body)
    );
  }

  /** Path part for operation `putHabitId()` */
  static readonly PutHabitIdPath = '/habit/{id}';

  /**
   * Update a Habit.
   *
   * Update a Habit
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `putHabitId()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  putHabitId$Response(params: PutHabitId$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = putHabitId(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Update a Habit.
   *
   * Update a Habit
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `putHabitId$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  putHabitId(params: PutHabitId$Params, context?: HttpContext): Observable<void> {
    const resp = this.putHabitId$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `deleteHabitId()` */
  static readonly DeleteHabitIdPath = '/habit/{id}';

  /**
   * Delete a Habit.
   *
   * Delete a Habit
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteHabitId()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteHabitId$Response(params: DeleteHabitId$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = deleteHabitId(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Delete a Habit.
   *
   * Delete a Habit
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteHabitId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteHabitId(params: DeleteHabitId$Params, context?: HttpContext): Observable<void> {
    const resp = this.deleteHabitId$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
